export default __webpack_public_path__ + "media/images/manual/ic/13-a766cd09b6cbf83b6c9cd76dc3bad5e0.png";